import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { s3 } from '~/utils/s3'

export function Trailers() {
    const trailers = [s3('/video/ape'), s3('/video/droid')]
    const trailerNames = ['Ape Cinematic', 'Droid Cinematic']
    const posters = [
        '/media/assets/landing/trailer_ape_preview.webp',
        '/media/assets/landing/trailer_droid_preview.webp',
    ]
    const [current, setCurrent] = useState(1)
    const [muted, setMuted] = useState(true)
    const detailsRef = useRef<HTMLDetailsElement>(null)

    const posterOnClick = (index: number) => {
        setCurrent(index)
        detailsRef.current?.removeAttribute('open')
    }

    return (
        // 65% of a phone screen is a ~240px video. The inset only earns its place once there is
        // width to spare.
        <div id='trailers' className='relative w-[92%] md:w-[65%] mx-auto contain-inline-size'>
            <details
                ref={detailsRef}
                className='absolute top-0 -left-1 -right-1 z-10 flex flex-col-reverse bg-black/50 backdrop-blur-sm select-none group/trailer text-[max(var(--text-2xs),0.75cqi)]'
            >
                <summary className='cursor-pointer list-none uppercase font-bold text-center p-2 '>
                    <span className='group-open/trailer:hidden'>
                        <FontAwesomeIcon icon={faCaretDown} /> Show Trailers <FontAwesomeIcon icon={faCaretDown} />
                    </span>
                    <span className='hidden group-open/trailer:inline'>
                        <FontAwesomeIcon icon={faCaretUp} /> Hide Trailers <FontAwesomeIcon icon={faCaretUp} />
                    </span>
                </summary>
                <div className='flex flex-row gap-[2em] p-[1em] items-center justify-center max-h-[75%]'>
                    {posters.map((poster, i) => (
                        <div
                            key={i}
                            className='group flex flex-col gap-2 cursor-pointer'
                            onClick={() => posterOnClick(i)}
                        >
                            <img src={poster} className='outline-1 outline-white/50 group-hover:outline' />
                            <div className='text-center font-bold uppercase whitespace-nowrap'>{trailerNames[i]}</div>
                        </div>
                    ))}
                </div>
            </details>
            <video
                key={trailers[current]}
                width={1920}
                height={1080}
                className='object-contain w-full h-auto'
                playsInline={true}
                muted={muted}
                autoPlay
                onClick={() => setMuted((prev) => !prev)}
                onEnded={() => setCurrent((prev) => (prev === 1 ? 0 : 1))}
            >
                <source src={`${trailers[current]}.mp4`} type='video/mp4' />
            </video>
        </div>
    )
}
